// /admin/v1/integrations — 平台级第三方集成密钥/配置 (DashScope/Qwen key 等).
//
// 后台填 API key/baseURL/model, worker 轮询热更 (准实时生效, 无需重启).
// 安全: 响应永不回 key 明文, 仅 has_key (已配置/未配置) + source (db/env/none).

import { get, put } from './client';

export type IntegrationProvider = 'dashscope';

// IntegrationConfig 是 GET /admin/v1/integrations/:provider 的脱敏读结构.
export interface IntegrationConfig {
  provider: string;
  // 是否已配置 API key (不回明文).
  has_key: boolean;
  base_url: string;
  model: string;
  enabled: boolean;
  // key 当前来源: 'db'=后台已填 | 'env'=仅环境变量 | 'none'=未配置.
  source: 'db' | 'env' | 'none';
  updated_at?: string;
}

// PutIntegrationInput 是写入体. api_key 省略/为空 = 保留原 key (改 baseURL/model 不必重填).
export interface PutIntegrationInput {
  api_key?: string;
  base_url: string;
  model: string;
  enabled: boolean;
}

export function getIntegrationConfig(provider: IntegrationProvider): Promise<IntegrationConfig> {
  return get<IntegrationConfig>(`/admin/v1/integrations/${provider}`);
}

export function putIntegrationConfig(
  provider: IntegrationProvider,
  input: PutIntegrationInput,
): Promise<IntegrationConfig> {
  return put<IntegrationConfig>(`/admin/v1/integrations/${provider}`, input);
}
